import { API_BASE_URL, HEADERS_WITH_TOKEN } from "./BaseUrl";

export const getBannersMultipleLinks = () =>
  fetch(
    `${API_BASE_URL}/banners-multiple-links`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  .then(res => res.json())


export const saveBannerMultipleLinks = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/banners-multiple-links`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const editBannerMultipleLinks = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/banners-multiple-links/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const deleteBannerMultipleLinks = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/banners-multiple-links/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  return await res.json()
}